export const memberType = {
  //get_employee_dependents\
  memberCoveredFail: 'MEMBER_COVERED_FAIL',

  memberCoveredSuccess: 'MEMBER_COVERED_SUCCESS',

  memberCoveredPending: 'MEMBER_COVERED_PENDING',

  //get_dependent_addition_permission
  additionPermissionPending: 'ADDITION_PERMISSION_PENDING',

  additionPermissionFail: 'ADDITION_PERMISSION_FAIL',

  additionPermissionSuccess: 'ADDITION_PERMISSION_SUCCESS',

  //(remove dependent) update_employee_dependents
  removeDependentPending: 'REMOVE_DEPENDENT_PENDING',

  removeDependentFail: 'REMOVE_DEPENDENT_FAIL',

  removeDependentSuccess: 'REMOVE_DEPENDENT_SUCCESS',
  //(UPDATE dependent) update_employee_dependents
  updateDependentPending: 'UPDATE_DEPENDENT_PENDING',

  updateDependentFail: 'UPDATE_DEPENDENT_FAIL',

  updateDependentSuccess: 'UPDATE_DEPENDENT_SUCCESS',

  persitMembersAdd: 'PERSIST_MEMBERS_Add',

  persitMembersRemove: 'PERSIST_MEMBERS_REMOVE',

  //fetch product Details

  getProductDetailsFail: 'GET_PRODUCT_DETAILS_FAIL',

  getProductDetailspending: 'GET_PRODUCT_DETAILS_PENDING',

  getProductDetailsSuccess: 'GET_PRODUCT_DETAILS_SUCCESS',

  // get products

  getEmployeeProductsPending: 'GET_EMPLOYEE_PRODUCTS_PENDING',

  getEmployeeProductsSuccess: 'GET_EMPLOYEE_PRODUCTS_SUCCESS',

  getEmployeeProductsFail: 'GET_EMPLOYEE_PRODUCTS_FAIL'
}
